'use client'

import clsx from 'clsx'
import { usePathname } from 'next/navigation'
import { FC, memo } from 'react'

import { AccessoriesPageProps } from './types'
import { AcsNavMenu } from './ui/acs-nav-menu/acs-nav-menu'
import { AcsPreview } from './ui/acs-preview/acs-preview'
import { BrandsSwiper } from './ui/brands-swiper/brands-swiper'
import { CatListGrid } from './ui/cat-list-grid/cat-list-grid'

import cl from './styles.module.scss'

export const AccessoriesPage: FC<AccessoriesPageProps> = memo(({ accessories, brands }) => {
	const pathname = usePathname()
	const isAcsRootRoute = pathname === '/catalog/aksessuary/'
	const brandItems = brands?.filter(({ IMAGE }) => IMAGE) || []

	const SHOW_CATS_SECTION = accessories?.sections?.length > 0
	const SHOW_POPULAR_CATS_SECTION = accessories?.popular?.length > 0
	const SHOW_ALL_CATS_SECTION = accessories && accessories.category?.length > 0
	const SHOW_BRANDS_SECTION = brandItems && brandItems.length > 0

	return (
		<div className={cl.root}>
			{isAcsRootRoute && <h1 className={cl.title}>{'Аксессуары'}</h1>}

			{!!accessories?.sections?.length && (
				<section className={clsx(cl.section, { [cl.section_hidden]: !SHOW_CATS_SECTION })}>
					{!isAcsRootRoute && <h1 className={cl.title}>{accessories.H1}</h1>}

					<AcsPreview items={accessories.sections} withBaseUrl />
				</section>
			)}

			<section
				className={clsx(
					cl.section,
					{ [cl.section_hidden]: !SHOW_POPULAR_CATS_SECTION },
					{ [cl.section_desktop]: isAcsRootRoute }
				)}>
				<h1 className={cl.title}>{isAcsRootRoute ? `Популярные категории` : accessories.H1}</h1>
				<AcsPreview items={accessories.popular} withBaseUrl className={cl.grid} />
			</section>

			<section className={clsx(cl.section, { [cl.section_hidden]: !SHOW_ALL_CATS_SECTION })}>
				<p className={clsx(cl.title, cl.title_desktop)}>Все категории</p>
				<CatListGrid items={accessories.category} />
				<AcsNavMenu items={accessories.category} />
			</section>

			<section className={clsx(cl.section, { [cl.section_hidden]: !SHOW_BRANDS_SECTION })}>
				<p className={cl.title}>Популярные бренды</p>
				<BrandsSwiper items={brandItems} />
			</section>
		</div>
	)
})
